import React, { FC, ReactElement } from 'react'
import Button from '@/components/button'
import classNames from 'classnames'

import TwitterIcon from '@/icons/twitter'
import styles from './TweetIntentButton.module.css'

const TweetIntentButton: FC<{
	className?: string
	buttonClassName?: string
	iconClassName?: string
	title?: string
	intent?: string
	size?: 'small' | 'medium' | 'large'
}> = (props): ReactElement => {
	const intent = props.intent
		? encodeURIComponent(props.intent)
		: 'I%20just%20joined%20the%20waitlist%20for%20%40ordinalswallet%20%F0%9F%9A%80%0A%0AJoin%20here%3A%20ordinalswallet.com%0A%0Aplz%20RT'

	return (
		<a
			className={classNames({ [(props.className as any)]: !!props.className }, styles.root)}
			target="_blank"
			href={`https://twitter.com/intent/tweet?text=${intent}`}
		>
			<Button
				size={props?.size}
				background="twitter-blue"
				className={classNames({ [(props.buttonClassName as any)]: !!props.buttonClassName }, styles.button)}
			>
				<TwitterIcon
					className={classNames({ [(props.iconClassName as any)]: !!props.iconClassName }, styles.icon)}
				/>
				{props.title ? props.title : 'Share it!'}
			</Button>
		</a>
	)
}

export default TweetIntentButton
